import { ChangeEvent, Children, forwardRef, ReactNode, Ref } from 'react';
import classnames from 'classnames';

import { InputLabel } from '@betrybe/ada-react';
import Select from '../../atoms/select';
import type { OptionsProps } from '../../atoms/select/Select';

type SelectInputProps = {
  disabled?: boolean;
  id: string;
  label?: string;
  onChange: (event: ChangeEvent<Element>) => void;
  placeholder: string;
  value: string;
  name: string;
  options: OptionsProps[];
  children?: ReactNode;
  className?: string;
  errorMessage: string;
};

const SelectInput = forwardRef(function SelectInput(
  props: SelectInputProps,
  ref: Ref<HTMLSelectElement>,
) {
  const {
    children,
    className,
    disabled,
    id,
    label,
    value,
    name,
    options,
    placeholder,
    onChange,
    errorMessage,
    ...selectProps
  } = props;

  return (
    <div className={classnames('flex flex-col', className)}>
      {label && (
        <InputLabel disabled={disabled} key={id} inputId={id}>
          {label}
        </InputLabel>
      )}
      <Select
        value={value}
        errorMessage={errorMessage}
        options={options}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        disabled={disabled}
        id={id}
        ref={ref}
        {...selectProps}
      >
        {Children.toArray(children)}
      </Select>
    </div>
  );
});

SelectInput.defaultProps = {
  children: '',
  className: '',
  label: undefined,
  disabled: false,
};

export default SelectInput;
